import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../_services/Authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    // IMPORTANTE: Los interceptores sólo se llaman cuando se hacen peticiones HTTP al servidor.
    // Si una sección o página no necesita comunicación con el servidor, entonces no se pasa por aquí.
    // Esta clase además está expresamente hecha para que sólo tenga en cuenta las peticiones HTTP que dan ERROR.
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // console.log('-->->* ErrorInterceptor: ...');
        // console.log(request);

        const provider = request.url.split('=');

        // NOTA: Aquí se añaden cabeceras especiales para ciertas apis (google geocode);
        if (provider[0] === 'https://maps.googleapis.com/maps/api/geocode/json?latlng') {
          const httpOptions = new HttpHeaders({
            });
          // @ts-ignore
          request.headers = httpOptions;
        }

        // Función que captura cualquier error en una respuesta y la tramita.
        // NOTA: Esta clase está expresamente hecha para que sólo tenga en cuenta
        // las peticiones HTTP que dan ERROR, no maneja las peticiones que funcionan
        // con normalidad (esas se manejan en la clase jw.interceptor.ts).
        return next.handle(request).pipe(catchError(err => {

            console.log('-->-->-->* ErrorInterceptor Error detectado:');
            console.log(err);

            if (err.status === 401) {
                // auto logout if 401 response returned from api

                if (err.error.message === 'Token is exp') {

                  console.log('--> ErrorInterceptor: El TOKEN ha expirado.');

                  // NOTA: Se refresca el token.
                  this.authenticationService.refreshToken();

                } else {

                    // Si es otro error se sale de la aplicación.
                    console.log('--> ErrorInterceptor: ERROR en aplicación:');
                    console.log(err.error.message);

                    // this.authenticationService.logout();
                    // location.reload();
                }
            }


            if (err.status === 423 && this.authenticationService.currentUserValue) {
                const message = err.error && (err.error.message || err.error.msg)
                    ? (err.error.message || err.error.msg)
                    : 'Tu acceso ha sido bloqueado. Contacta con soporte.';
                this.authenticationService.redirectToLoginForAccessBlock(message);
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
